import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@/app/App";
import "@/i18n/i18n";
import "@/index.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element #root not found");
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
